import { QuestionMarkCircleIcon } from "@heroicons/react/24/outline";
import { WhiteLabelContentMode } from "generated/graphql";
import React, { useCallback } from "react";
import { useWhiteLabelContentMode } from "store/selectors/branding";
import { useFeature } from "store/selectors/hooks";

interface HasBeacon {
    Beacon?: (action: string, configOrEvent?: unknown) => void;
}

export const SupportTrayItem: React.FC = () => {
    const contentMode = useWhiteLabelContentMode();
    const supportIconRelocate = useFeature("supportIconRelocate");

    const handleClick = useCallback(() => {
        const Beacon = (window as HasBeacon).Beacon;
        if (Beacon) {
            Beacon("config", { display: { style: "manual", position: "right" } });
            Beacon("open");
        }
    }, []);

    if (!supportIconRelocate || contentMode !== WhiteLabelContentMode.Full) {
        return null;
    }

    return (
        <button
            onClick={handleClick}
            className="relative p-1.5 rounded-lg hover:bg-zinc-950/5 dark:hover:bg-white/5 focus:outline-none"
            aria-label="Support">
            <QuestionMarkCircleIcon className="size-5 text-zinc-500" />
        </button>
    );
};
